<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title> {{'Lista de Presença' | translate}} </ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-searchbar
      show-cancel-button="never"
      class="custom"
      [(ngModel)]="filtro"
      placeholder="Buscar por nome"
    ></ion-searchbar>
  </div>
  <ion-grid>
    <div class="gradient-extendido-div">
      <div class="div-top">
        <ion-note slot="start">
          <i class="fas fa-users div-icon" style="margin-top: 2px"></i>
        </ion-note>

        <ion-label class="color-title"> {{'Pessoas presentes' | translate}} </ion-label>
      </div>
    </div>

    <ion-row *ngFor="let a of lideradosFiltrados;">
      <ion-col size="12">
        <ion-list>
          <ion-item>
            <ion-avatar slot="start">
              <img [src]="a.foto | image:' '" />
            </ion-avatar>

            <ion-toggle
              [enableOnOffLabels]="true"
              class="bold-1"
              [ngModel]="a.presenca == '1'"
              (ngModelChange)="changePresenca(a)"
              [disabled]="loadingPresenca[a.idPessoa]"
            >
              <p>{{a.nome}}</p>
            </ion-toggle>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
